import { useNavigate } from 'react-router-dom'
import './LandingPage.css'

export default function LandingPage() {
  const navigate = useNavigate()

  return (
    <div className="landing">
      {/* Navigation */}
      <nav className="landing-nav">
        <div className="landing-nav-inner">
          <div className="landing-logo">
            <span className="logo-icon">M</span>
            <span className="logo-text">Medi-Lane</span>
          </div>
          <div className="landing-nav-actions">
            <a href="/arbeitgeber" className="nav-link">Für Arbeitgeber</a>
            <a href="/admin/login" className="nav-link">Admin</a>
            <button className="landing-cta-nav" onClick={() => navigate('/funnel')}>
              Jetzt starten →
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg">
          <div className="hero-gradient" />
          <div className="hero-dots" />
        </div>
        <div className="hero-content">
          <div className="hero-badge animate-fade-in">
            <span className="badge-dot" />
            Kostenlos & unverbindlich
          </div>
          <h1 className="hero-title animate-fade-in-up">
            Ihr neuer Job<br />
            <span className="hero-highlight">in der Pflege</span><br />
            wartet auf Sie
          </h1>
          <p className="hero-subtitle animate-fade-in-up">
            Finden Sie in nur 3 Minuten den perfekten Arbeitgeber. 
            Wir matchen Ihre Wünsche mit passenden Stellen — diskret & kostenlos.
          </p>
          <div className="hero-actions animate-fade-in-up">
            <button className="cta-button cta-button--primary" onClick={() => navigate('/funnel')}>
              <span className="cta-icon">🚀</span>
              Profil erstellen — kostenlos
            </button>
            <a href="#so-funktionierts" className="cta-button cta-button--secondary">
              So funktioniert's
            </a>
          </div>
          <div className="hero-trust animate-fade-in">
            <div className="trust-item">
              <span className="trust-icon">🔒</span>
              <span>DSGVO-konform</span>
            </div>
            <div className="trust-divider" />
            <div className="trust-item">
              <span className="trust-icon">⏱️</span>
              <span>3 Min. Aufwand</span>
            </div>
            <div className="trust-divider" />
            <div className="trust-item">
              <span className="trust-icon">💰</span>
              <span>100% kostenlos</span>
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section id="so-funktionierts" className="section steps-section">
        <div className="section-inner">
          <h2 className="section-title">So funktioniert's</h2>
          <p className="section-subtitle">In drei einfachen Schritten zu Ihrem Traumjob</p>
          
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <div className="step-icon">📋</div>
              <h3 className="step-title">Profil erstellen</h3>
              <p className="step-desc">
                Beantworten Sie in 3 Minuten einige Fragen zu Ihren Wünschen, 
                Erfahrungen und Prioritäten.
              </p>
            </div>
            <div className="step-connector">
              <div className="connector-line" />
              <div className="connector-arrow">→</div>
            </div>
            <div className="step-card">
              <div className="step-number">2</div>
              <div className="step-icon">🎯</div>
              <h3 className="step-title">Automatisches Matching</h3>
              <p className="step-desc">
                Unser System findet passende Arbeitgeber, die genau zu 
                Ihren Vorstellungen passen.
              </p>
            </div>
            <div className="step-connector">
              <div className="connector-line" />
              <div className="connector-arrow">→</div>
            </div>
            <div className="step-card">
              <div className="step-number">3</div>
              <div className="step-icon">🤝</div>
              <h3 className="step-title">Angebote erhalten</h3>
              <p className="step-desc">
                Wir stellen Sie anonymisiert vor — Sie entscheiden, 
                ob Kontakt aufgenommen wird.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="section benefits-section">
        <div className="section-inner">
          <h2 className="section-title">Warum Medi-Lane?</h2>
          <p className="section-subtitle">Wir nehmen Ihnen die Arbeit ab — Sie genießen die Vorteile</p>
          
          <div className="benefits-grid">
            <div className="benefit-card">
              <span className="benefit-icon">🎯</span>
              <h3>Persönliches Matching</h3>
              <p>Kein Durchsuchen von Stellenanzeigen. Wir finden den perfekten Fit basierend auf Ihren Prioritäten.</p>
            </div>
            <div className="benefit-card">
              <span className="benefit-icon">🤫</span>
              <h3>100% diskret</h3>
              <p>Ihr aktueller Arbeitgeber erfährt nichts. Ihr Profil wird nur anonymisiert vorgestellt.</p>
            </div>
            <div className="benefit-card">
              <span className="benefit-icon">💶</span>
              <h3>Kostenlos für Sie</h3>
              <p>Für Pflegekräfte ist unser Service vollständig kostenlos. Immer und ohne versteckte Kosten.</p>
            </div>
            <div className="benefit-card">
              <span className="benefit-icon">📊</span>
              <h3>Gehalt vergleichen</h3>
              <p>Erfahren Sie, was Sie wert sind – und finden Sie Arbeitgeber, die das auch zahlen.</p>
            </div>
            <div className="benefit-card">
              <span className="benefit-icon">🏥</span>
              <h3>Alle Bereiche</h3>
              <p>Intensiv, Notauf­nahme, OP, Ambulant, Reha – wir decken alle Pflegebereiche ab.</p>
            </div>
            <div className="benefit-card">
              <span className="benefit-icon">⚡</span>
              <h3>Schnelle Rückmeldung</h3>
              <p>Innerhalb von 48 Stunden erhalten Sie eine Rückmeldung mit passenden Angeboten.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="cta-box">
          <h2 className="cta-title">Bereit für den Wechsel?</h2>
          <p className="cta-subtitle">
            Erstellen Sie jetzt Ihr Profil und erhalten Sie passende Jobangebote — 
            kostenlos und unverbindlich.
          </p>
          <button className="cta-button cta-button--primary cta-button--lg" onClick={() => navigate('/funnel')}>
            <span className="cta-icon">🚀</span>
            Jetzt Profil erstellen
          </button>
          <p className="cta-note">Kein Account nötig · 3 Minuten · DSGVO-konform</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <div className="landing-logo">
              <span className="logo-icon logo-icon--sm">M</span>
              <span className="logo-text">Medi-Lane</span>
            </div>
            <p className="footer-tagline">Ihre Karriere in der Pflege — neu gedacht.</p>
          </div>
          <div className="footer-links">
            <a href="/funnel">Profil erstellen</a>
            <a href="/arbeitgeber">Für Arbeitgeber</a>
            <a href="#">Datenschutz</a>
            <a href="#">Impressum</a>
          </div>
          <p className="footer-copy">© {new Date().getFullYear()} Medi-Lane. Alle Rechte vorbehalten.</p>
        </div>
      </footer>
    </div>
  )
}
